import ContainedIcon from '@/components/ContainedIcon';
import BookIcon from '@/components/Icons/BookIcon';

function DocsIcon() {
  return (
    <ContainedIcon size={24} color="background.subtle" borderRadius={6}>
      <BookIcon />
    </ContainedIcon>
  );
}

export default DocsIcon;
